import { RefObject } from 'react'
import { useSelector } from 'react-redux'

import * as Styled from './styled'
import Aspect169Icon from 'assets/svgr-icons/Aspect_Ratio_16_9_Dropdown.svg'
import { getAspectRatioOptions } from 'containers/Header/AspectRatioSelect/consts'
import { useAspectRatioSwitch } from 'hooks/useAspectRatioSwitch'
import { useAspectRatioWarning } from 'hooks/useAspectRatioWarning'
import AspectRatioWarningPopup from 'common-components/AspectRatioWarningPopup'
import { editorSelectors } from 'store/features/editor/selectors'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { UserDropdownExpandable } from '../UserDropdownExpandable'

interface IProps {
  scrollableContentWrapperRef: RefObject<HTMLDivElement | null>
}

export const UserDropdownAspectRatio: React.FC<IProps> = ({
  scrollableContentWrapperRef
}) => {
  const { aspectRatioString } = useAspectRatioSwitch()
  const storedSelectedKey = useSelector(editorSelectors.selectedAspectRatioKey)
  const hasMediaItemsWithSource = useSelector(
    projectDataSelectors.hasMediaItemsWithSource
  )
  const {
    handleAspectRatioClick,
    showWarning,
    pendingSelection,
    handleConfirmSwitch,
    handleCancelSwitch
  } = useAspectRatioWarning()

  const allOptions = getAspectRatioOptions()
  const currentOption = storedSelectedKey
    ? allOptions.find(o => o.key === storedSelectedKey)
    : allOptions.find(o => o.ratio === aspectRatioString)
  const CurrentIcon = currentOption?.icon ?? Aspect169Icon
  const triggerLabel =
    currentOption?.key === 'original' ? currentOption.label : aspectRatioString

  const options = allOptions
    .filter(opt => opt.key !== currentOption?.key)
    .map(opt => ({ ...opt, id: opt.key }))

  return (
    <>
      <UserDropdownExpandable
        triggerId="aspect-ratio"
        triggerIcon={CurrentIcon}
        triggerLabel={triggerLabel}
        options={options}
        renderOption={opt => {
          const OptionIcon = opt.icon
          return (
            <>
              <Styled.IconWrapper>
                <OptionIcon />
              </Styled.IconWrapper>
              <Styled.Label>{opt.label}</Styled.Label>
              {opt.key !== 'original' && (
                <Styled.Ratio>{opt.ratio}</Styled.Ratio>
              )}
            </>
          )
        }}
        onSelect={opt => handleAspectRatioClick(opt.key)}
        isOptionDisabled={opt =>
          opt.key === 'original' && !hasMediaItemsWithSource
        }
        scrollableContentWrapperRef={scrollableContentWrapperRef}
      />

      <AspectRatioWarningPopup
        isOpen={showWarning}
        pendingSelection={pendingSelection}
        onConfirm={handleConfirmSwitch}
        onCancel={handleCancelSwitch}
      />
    </>
  )
}
